export const baseurl = "https://3fb33476-6917-46b7-b477-b9d042878d8f-00-11afbk2r8x24b.sisko.replit.dev"
